import React, { Component } from 'react'
import axios from 'axios'
import './SpellCorrectionVendor.css'
import { toast } from 'react-toastify'
import Loader from '../Loader'
import ProgressBar from '../ProgressBar/ProgressBar'
import { Urls } from '../../Urls'
import { constants } from '../../constants'
import { logActivity } from '../Utilities'
var raw_suggestions = []
var raw_manual = []
var raw_final = []

class SpellCorrectionVendor extends Component {
    constructor(props) {
        super(props)

        this.state = {
            fetched_data: [],
            status: 0,
            input: [],
            search: [],
            loader: false
        }
    }

    componentDidMount = () => {
        // logActivity([
        //     {
        //         'screen': 'Spell Correction Vendor',
        //         'module': 'Vendor Cleaning',
        //         'user_activity': 'page viewed',
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
        document.title = "DC | Spell Check"
        document.getElementById("header").style.opacity = "0.5"
        const body = {
            "dataset_id": localStorage.getItem("dataset_id"),
            "collection_name": "spell_sugg_ven",
            "key": "vendor"
        }

        this.setState({
            loader: true
        }, () => {
            axios.post(Urls.dataset.fetch, body)
                .then(response => {
                    this.setState({
                        fetched_data: response.data.data,
                        search: response.data.search,
                        loader: false
                    }, () => { if (this.state.fetched_data.length === 0) { this.skip() } })
                    document.getElementById("header").style.opacity = "1"
                    var i;
                    for (i = 0; i < this.state.fetched_data.length; i++) {
                        if (this.state.fetched_data[i].Suggestion.length === 0) {
                            raw_suggestions.push({
                                "suggestion": this.state.fetched_data[i].Vendor
                            })
                        }
                        else {
                            raw_suggestions.push({
                                "suggestion": this.state.fetched_data[i].Suggestion[0]
                            })
                        }
                    }
                    raw_final.push(raw_suggestions)
                    for (i = 0; i < this.state.fetched_data.length; i++) {
                        raw_manual.push({
                            "manual": ""
                        })
                    }
                    raw_final.push(raw_manual)

                })
                .catch(error => {
                    this.setState({
                        loader: false
                    })
                    toast.error("Failed while fetching yout data")
                    console.log(error)
                })
        })

    }

    skip = () => {
        var body = {
            "dataset_id": localStorage.getItem("dataset_id"),
            "key": "vendor"
        }
        this.setState({
            loader: true
        }, () => {
            axios.post(Urls.master, body)
                .then(response => {
                    // New body to be used by API
                    console.log("Master for vendor has been executed")
                    console.log(response)
                    this.setState({ loader: false })
                    document.getElementById("header").style.opacity = "1"
                    sessionStorage.setItem('prevScreen', this.props.history.location.pathname)
                    this.props.history.push({ pathname: "/directMatchTruck" })
                })
                .catch(error => {
                    console.log(error)
                })
        })
    }

    selectHandler = event => {
        if (event.target.value === "Other") {
            raw_suggestions[event.target.name] = { "suggestion": event.target.value }
            document.getElementById(event.target.name).disabled = false
        }
        else {
            raw_suggestions[event.target.name] = { "suggestion": event.target.value }
            document.getElementById(event.target.name).disabled = true
            document.getElementById(event.target.name).style.border = "none"
        }

    }

    manualHandler = event => {
        this.setState({ status: 1 })
        raw_manual[event.target.id] = { "manual": event.target.value }
    }

    submitHandler = (e) => {
        e.preventDefault()
        var emptyRows = []
        var i = 0
        for (i = 0; i < raw_manual.length; i++) {
            if (raw_suggestions[i]['suggestion'] === "Other") {
                if (new RegExp(constants.regex_patterns.emptyString).test(raw_manual[i]['manual'])) {
                    emptyRows.push(`Row: ${i + 1}`)
                    // alert(`You left empty vendor name at Row: ${i + 1}`)
                    document.getElementById(i).style.border = '1px solid red'
                }
                else {
                    document.getElementById(i).style.border = 'none'
                }
            }
        }
        if (emptyRows.length === 0) {
            // logActivity([
            //     {
            //         'screen': 'Spell Correction Vendor',
            //         'module': 'Vendor Cleaning',
            //         'user_activity': 'data submission',
            //         'timestamp': new Date().toISOString()
            //     }
            // ])
            document.getElementById("header").style.opacity = "0.5"
            var body = {}
            if (this.state.status === 1) {
                raw_final = []
                raw_final.push(raw_suggestions)
                raw_final.push(raw_manual)
                this.setState({
                    input: raw_final
                }, () => { })
                body = {
                    "dataset_id": localStorage.getItem("dataset_id"),
                    "collection_name": "spell_sugg_ven",
                    "input": raw_final,
                    "key": "vendor"
                }
            }
            else {
                this.setState({
                    input: raw_final
                }, () => { })
                body = {
                    "dataset_id": localStorage.getItem("dataset_id"),
                    "collection_name": "spell_sugg_ven",
                    "key": "vendor",
                    "input": raw_final
                }
            }
            this.setState({
                loader: true
            }, () => {
                axios.post(Urls.dataset.dump, body)
                    .then(response => {
                        document.getElementById("header").style.opacity = "1"
                        this.setState({ loader: false })
                        sessionStorage.setItem('prevScreen', this.props.history.location.pathname)
                        this.props.history.push({
                            pathname: "/directMatchTruck"
                        })
                        console.log(response)
                        // Dataset master API call must be called dumping_master
                    })
                    .catch(error => {
                        this.setState({ loader: false })
                        toast.error("Error while processing your request")
                        console.log(error)
                    })
            })
        }
        else {
            alert('Please enter vendor name.')
        }



    }

    goBack = () => this.props.history.push({ pathname: "/directMatchVendor" })

    goToSummary = () => this.props.history.push({ pathname: "/summaryScreen" })


    render() {
        var fetched_details = this.state.fetched_data
        var search_data = this.state.search
        return (
            <div id="header">
                <div className={'tooltip-absolute'}>
                    <div className={'top-tooltip-container'}>
                        <div className={'top-tooltip-element'}>
                            <i style={{ fontSize: '20px' }} className={'fa fa-info-circle'}></i>
                        </div>
                        <div className={'top-tooltip-message'}>
                            Uncleaned Vendors are highlighted in yellow color!
                        </div>
                    </div>
                </div>
                <Loader isLoading={this.state.loader} />
                <div className="container">
                    <div style={{ "margin-bottom": "5%" }} >
                        <div className="row" align="center">
                            <div className="col-1">
                                <button onClick={this.goBack}><i className="navButtonsCircleLeft fas fa-arrow-circle-left"></i></button>
                            </div>
                            <div className="col-10">
                                <table border="1" id="dc_table">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Raw Transporter Name</th>
                                            <th>Suggestion</th>
                                            <th>User Input</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            fetched_details.map((detail, i) =>
                                                (detail.Suggestion.length === 0) ? (
                                                    <tr style={{ "backgroundColor": "#f1fa3c" }}>
                                                        <td> {i + 1} </td>
                                                        <td> {detail.Vendor} </td>
                                                        <td>
                                                            <select name={i} onChange={this.selectHandler} >
                                                                <option value={detail.Vendor}> {detail.Vendor} </option>
                                                                <option value="Other">Other</option>
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <input className="form-control" required list="auto_complete" onChange={this.manualHandler} id={i} type="text" placeholder="Vendor Name" disabled />
                                                            <datalist id="auto_complete">
                                                                {
                                                                    search_data.map(e => <option value={e}> {e} </option>)
                                                                }
                                                            </datalist>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                        <tr>
                                                            <td> {i + 1} </td>
                                                            <td> {detail.Vendor} </td>
                                                            <td>

                                                                <select name={i} onChange={this.selectHandler} >
                                                                    {
                                                                        detail.Suggestion.map(s => <option value={s} > {s} </option>
                                                                        )
                                                                    }
                                                                    <option value="Other">Other</option>
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <input className="form-control" required list="auto_complete" onChange={this.manualHandler} id={i} type="text" placeholder="User Input" disabled />
                                                                <datalist id="auto_complete">
                                                                    {
                                                                        search_data.map(e => <option value={e}> {e} </option>)
                                                                    }
                                                                </datalist>
                                                            </td>
                                                        </tr>
                                                    )
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-1 navButtonsCircleRight">
                                <button onClick={this.submitHandler} title="Submit" ><i className=" fas fa-arrow-circle-right"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer_div">
                    <ProgressBar progress="67%" />
                </div>
            </div >
        )
    }
}

export default SpellCorrectionVendor
